import React from 'react';

export const Login = () => {
    return (
        <div>
            Login Page
        </div>
    );
};